/**
 * BackToClients: the back control on the client record. Where the person
 * came from when the record was opened from inside Olive (the browser's
 * history), else the full roster at /clients/all (a deep link, a
 * refresh, an outside referrer). The roster keeps only its view in the
 * URL, so its search, filters and sort start fresh either way.
 */
import type { ReactNode } from 'react';
import { BackControl } from '@/components/BackControl';

export function BackToClients({ tenantSlug }: { tenantSlug: string }): ReactNode {
  return (
    <BackControl
      label="All clients"
      ariaLabel="Back to all clients"
      to={`/t/${encodeURIComponent(tenantSlug)}/clients/all`}
      testId="back-to-clients"
      className="mb-4"
    />
  );
}
